import { actionTypes } from '../constants/actionTypes';

export const orderDetailValues = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ORDER_DETAIL_VALUES:
      return Object.assign({}, state, action.payload);
  }

  return state;
};
